module.exports = __webpack_public_path__ + "media/images/lp_flow-cv-siryou-f2ff4232d73d9d5a66ff343c0258fe15.webp";